export default __webpack_public_path__ + "static/chrome-eb08c191716de3fc6488e36d636378d3.svg";